import type { JSX } from 'react'

/**
 * Same markup as the pre-mount splash in `index.html` so the sprite + phrase
 * stay on screen while React hydrates and `/me` resolves. The `.boot-splash`
 * CSS lives in `index.html` and is global, so no styles are needed here.
 */
export function BootSplash(): JSX.Element {
  return (
    <div className="boot-splash">
      <svg
        className="logo"
        viewBox="0 0 200 200"
        width="64"
        height="64"
        aria-hidden="true"
      >
        <line className="stroke s1" x1="65" y1="60" x2="134" y2="139" />
        <line className="stroke s2" x1="120" y1="44" x2="79" y2="155" />
        <line className="stroke s3" x1="171" y1="49" x2="28" y2="149" />
      </svg>
      <div className="phrases">
        <div className="phrase">Rest is part of the work.</div>
        <div className="phrase">Coverage planned. Coffee earned.</div>
        <div className="phrase">Counting your days back to you.</div>
        <div className="phrase">Burnout isn&apos;t a strategy — leave is.</div>
        <div className="phrase">Approvals in flight. Calendars syncing.</div>
        <div className="phrase">Time off you&apos;ve earned, time off you&apos;ll take.</div>
      </div>
    </div>
  )
}
